// TODO(mike): I've moved these params here so that they can be shared, but
// there's still a lot of cleanup to be done. We have at least two different
// case conventions below. And I think having multiple enums means that there's
// no protection against url param conflicts.

/**
Tracks the names of arguments in the query string that are
added as query params (e.g. /jobs?jobId=123&tab=details)
Since query params are global state, setting arguments and fetching
arguments using these enum values helps avoid conflicts.
NOTE: if a query param name conflicts with a Next dynamic route
param name, and both are matched on the url, the dynamic route param
will take precedence.
*/
export enum QueryParamName {
  CC_ME = 'ccMe',
  DRAWER_TAB = 'tab',
  SETTINGS_TAB = 'settings-tab',
  SETTINGS_SECTION = 'settings-section',
  JOB_ID = 'jobId',
  ORDER_ID = 'orderId',
  SHIPMENT_ID = 'shipmentId',
  MOVEMENT_ID = 'movementId',
  SCHEDULE_PLAN_ID = 'schedulePlanId',
  ORGANIZATION_ID = 'organizationId',
  ORIGINATOR_ID = 'originatorId',
  PLACE_ID = 'placeId',
  USER_ID = 'userId',
  SEARCH_TERM = 'search-term',
  VOICE_TRANSCRIPT_SEARCH_TERM = 'voice-transcript-search-term',
  SHOW_ORPHANED_ONLY = 'show-orphaned-only',
  SOP_VIEW = 'sop-view',
  SOP_TAG = 'sop-tag',
  MEMBER_ID = 'memberId',
  QUOTE_ID = 'quoteId',
  ONBOARDING_FORM_IS_OPEN = 'onboardingFormIsOpen',
  LABELING_ENTITY_ID = 'labelingEntityId',
  LABELING_ENTITY_TYPE = 'labelingEntityType',
  ORIGIN_PLACE_ID = 'originPlaceId',
  DESTINATION_PLACE_ID = 'destinationPlaceId',
  COMPUTATION_TYPE = 'computationType',
  COMPUTATION_ID = 'computationId',
  LABELED_COMPUTATION_ID = 'labeledComputationId',
  DOCS_ENTITY_ID = 'docsEntityId',
  DOCS_ENTITY_TYPE = 'docsEntityType',
  INSIGHTS_DASHBOARD = 'insightsDashboard',
  DRAFT_REPLY = 'draftReply',
  CONVERSATION_ID = 'conversationId',
  // NOTE(mike): The chats page uses its own param because CONVERSATION_ID
  // triggers the global conversation side drawer via useGlobalDrawer.
  CHAT_CONVERSATION_ID = 'chatConversationId',
  ACTIVE_CONVERSATION_ID = 'activeConversationId',
  WORKER_USER_ID = 'workerUserId',
  ACTION_DEFINITION_ID = 'actionDefinitionId',
  GLOBAL_PROMPT_ID = 'globalPromptId',
  TEAM_ID = 'teamId',
  WORKER_ID = 'workerId',
  TASK_ID = 'taskId',
  EXCEPTION_ID = 'exceptionId',
  CONFIGURE_ORIGINATOR_ID = 'configureOriginatorId',
  UTM_SOURCE = 'utm_source',
  MEMORY_ID = 'memoryId',
  CARRIER_ID = 'carrierId',
  GENERIC_TRANSFORMATION_ID = 'genericTransformationId',
  TASK_VISUALIZATION_SETTINGS = 'task-visualization-settings',
  OFFER_MOVEMENT_ID = 'offerMovementId',
  OFFER_TAB = 'offerTab',
  OUTBOUND_MOVEMENT_ID = 'outboundMovementId',
  TRACK_MOVEMENT_ID = 'trackMovementId',
  SHARED_FILE_ID = 'sharedFileId',
  TRACK_SETTINGS_PAGE = 'track-page',
  COVER_SETTINGS_PAGE = 'cover-page',
  TRACK_SETTINGS_PROFILE = 'track-profile',
  TRACK_SELECTED_MOVEMENT_ID = 'selectedMovementId',
  TRACK_SELECTED_THREAD_ID = 'selectedThreadId',
  TRACK_SELECTED_RUN_ID = 'selectedRunId',
  TRACK_SELECTED_CALL_ID = 'selectedCallId',
  TRACK_SELECTED_DOCUMENT_ID = 'selectedDocumentId',
  TRACK_CONVERSATION_FILTER = 'conversationFilter',
  TRACK_SELECTED_EVENT_ID = 'selectedEventId',
}

export enum DrawerKind {
  CARRIER = 'CARRIER',
  JOB = 'JOB',
  ORIGINATOR = 'ORIGINATOR',
  ORGANIZATION = 'ORGANIZATION',
  PLACE = 'PLACE',
  MEMBER = 'MEMBER',
  QUOTE = 'QUOTE',
  USER = 'USER',
  CONVERSATION = 'CONVERSATION',
  TEAM = 'TEAM',
  WORKER = 'WORKER',
  TASK = 'TASK',
  SHIPMENT = 'SHIPMENT',
  MOVEMENT = 'MOVEMENT',
  MEMORY = 'MEMORY',
  EXCEPTION = 'EXCEPTION',
  GENERIC_TRANSFORMATION = 'GENERIC_TRANSFORMATION',
  TRACKING_MILESTONES = 'TRACKING_MILESTONES',
}

export enum SettingsSection {
  EMAIL_SETTINGS = 'email-settings',
  ANALYTICS_SETTINGS = 'analytics-settings',
  NOTIFICATION_SETTINGS = 'notification-settings',
  INBOX_AUTOMATION = 'inbox-automation',
  EXCEPTION_SETTINGS = 'exception-settings',
  QUOTE_AUTOMATION = 'quote-automation',
  QUOTE_SETTINGS = 'quote-settings',
  BUILD_SETTINGS = 'build-settings',
  COVER_SETTINGS = 'cover-settings',
  EQUIPMENT_MAPPINGS = 'equipment-mappings',
  SCHEDULE_SETTINGS = 'schedule-settings',
  TRACK_SETTINGS = 'track-settings',
}

export enum DrawerTabValue {
  DETAILS = 'details',
  RATES = 'rates',
  DOCUMENTS = 'documents',
  TEMPLATES = 'templates',
  SENDERS = 'senders',
  INTEGRATIONS = 'integrations',
  MEMBERS = 'members',
  EDITOR = 'editor',
  WORKFLOWS = 'workflows',
  AUDIT_TRAIL = 'audit-trail',
  INBOX_AUTOMATION = 'inbox-automation',
  PRICING = 'pricing',
  GENERAL_SETTINGS = 'general-settings',
  ACTION_DEFINITIONS = 'action-definitions',
  SETTINGS = 'settings',
  TEAMS = 'teams',
  ACCOUNTS = 'accounts',
  EMAIL_SIGNATURES = 'email-signatures',
  VOOMA_API = 'vooma-api',
  SCHEDULE = 'schedule',
  COVER = 'cover',
  TRACK = 'track',
  PROVISIONING = 'provisioning',
  RESOURCES = 'resources',
  EXTERNAL_CHANNELS = 'external-channels',
  GLOBAL_PROMPTS = 'global-prompts',
  GUMSHOE = 'gumshoe',
  MAILBOXES = 'mailboxes',
  NOTIFICATION_SETTINGS = 'notification-settings',
  CANARIES = 'canaries',
  OPERATIONS = 'operations',
  SIMULATION = 'simulation',
  RULE_TEMPLATES = 'rule-templates',
  SOP_PARAMS = 'sop-params',
  OVERVIEW = 'overview',
  FREIGHT_DATA_MAPPINGS = 'freight-data-mappings',
  ACCESS_POLICIES = 'access-policies',
  USAGE = 'usage',
  BILLING = 'billing',
}

export enum DropdownQueryParam {
  ORGANIZATION = 'organization',
  ORIGINATOR_ID = 'originator-id',
  ORIGINATOR_STATUS = 'originator-status',
  PLACE_ID = 'place-id',
  EXTERNAL_MESSAGE_ID = 'external-message-id',
  USER_ID = 'user-id',
  JOB_STATUS = 'job-status',
  QUOTE_STATUS = 'quote-status',
  PLACE_TAG = 'place-tag',
  AUCTION_TYPE = 'auction-type',
  CONTRACT_TYPE = 'contract-type',
  PICKUP_LOCATION = 'pickup-location',
  DELIVERY_LOCATION = 'delivery-location',
  CREATED_AT_START_DATE = 'created-at-start-date',
  CREATED_AT_END_DATE = 'created-at-end-date',
  LAST_ACTIVE_START_DATE = 'last-active-start-date',
  LAST_ACTIVE_END_DATE = 'last-active-end-date',
  PICKUP_FIRST_DATE = 'pickup-first-date',
  PICKUP_SECOND_DATE = 'pickup-second-date',
  DELIVERY_FIRST_DATE = 'delivery-first-date',
  DELIVERY_SECOND_DATE = 'delivery-second-date',
  CUSTOM_MIN_VALUE = 'custom-min-value',
  CUSTOM_MAX_VALUE = 'custom-max-value',
  SUBMITTED = 'submitted',
  ORIGIN_PLACE_ID = 'origin-place-id',
  DESTINATION_PLACE_ID = 'destination-place-id',
  COMPUTATION_TYPE = 'computation-type',
  EQUIPMENT_TYPE = 'equipment-type',
  MEMBER_ROLE = 'member-role',
  FREIGHT_MODE = 'freight-mode',
  LABEL_STATUS = 'label-status',
  CONVERSATION_STATUS = 'conversation-status',
  TEAM_ID = 'team-id',
  SAVED_CLASSIFICATION = 'saved-classification',
  LABELED_CLASSIFICATION = 'labeled-classification',
  VOOMA_CONFIRMATION_STATUS = 'vooma-confirmation-status',
  SINCE_DAYS_AGO = 'since-days-ago',
  TO_DAYS_AHEAD = 'to-days-ahead',
  TASK_MODE = 'task-mode',
  FROM_PHONE_NUMBER = 'from-phone-number',
  TO_PHONE_NUMBER = 'to-phone-number',
  CONVERSATION_LABELS = 'conversation-labels',
  ACTION_DEFINITION_ID = 'action-definition-id',
  LOADBOARD = 'loadboard',
  HAS_CARRIER = 'has-carrier',
  ON_HOLD = 'on-hold',
  CUSTOM_FREIGHT_TAGS = 'custom-freight-tags',
  AUTO_SUBMIT_SCOPE = 'auto-submit-scope',
  QUOTE_AUTO_REPLY_SCOPE = 'quote-auto-reply-scope',
  THREAD_LENGTH = 'thread-length',
  TRACKING_TYPE = 'tracking-type',
  SOP_TAG = 'sop-tag',
  OPTIMISM_STATUS = 'optimism-status',
  TRACK_ENABLED = 'track-enabled',
  TRACK_REP = 'track-rep',
  TRACK_CARRIER = 'track-carrier',
  TRACK_SHIPPER = 'track-shipper',
  TRACK_LOAD_FLAG = 'track-load-flag',
  OPERATIONAL_ISSUE_TAG = 'operational-issue-tag',
  OPERATIONAL_ISSUE_SEVERITY = 'operational-issue-severity',
}
